(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__lfCountdownBound) return;
  window.__lfCountdownBound = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function pad(n) {
    return String(n < 0 ? 0 : n).padStart(2, '0');
  }

  function init(root) {
    if (root.dataset.lfReady === 'true') return;
    root.dataset.lfReady = 'true';

    var hours = parseInt(root.getAttribute('data-hours'), 10);
    var minutes = parseInt(root.getAttribute('data-minutes'), 10);
    hours = isNaN(hours) ? 1 : Math.min(23, Math.max(0, hours));
    minutes = isNaN(minutes) ? 59 : Math.min(59, Math.max(0, minutes));

    var out = {
      days: root.querySelector('[data-lf-cd="days"]'),
      hours: root.querySelector('[data-lf-cd="hours"]'),
      minutes: root.querySelector('[data-lf-cd="minutes"]'),
      seconds: root.querySelector('[data-lf-cd="seconds"]')
    };
    if (!out.seconds) return;

    var total = hours * 3600 + minutes * 60 + 59;

    function render(remaining) {
      if (out.days) out.days.textContent = pad(Math.floor(remaining / 86400));
      if (out.hours) out.hours.textContent = pad(Math.floor((remaining % 86400) / 3600));
      if (out.minutes) out.minutes.textContent = pad(Math.floor((remaining % 3600) / 60));
      if (out.seconds) out.seconds.textContent = pad(remaining % 60);
    }

    render(total);

    // Reduced motion: show the starting time and never tick.
    if (reduced && reduced.matches) return;

    var endsAt = Date.now() + total * 1000;
    var timer = window.setInterval(function () {
      if (!root.isConnected) {
        window.clearInterval(timer);
        return;
      }
      var left = Math.max(0, Math.round((endsAt - Date.now()) / 1000));
      render(left);
      if (left <= 0) window.clearInterval(timer);
    }, 1000);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lf-countdown]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-lf-sort-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var form = sel.closest('form');
        if (form) form.submit();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  var buttons = document.querySelectorAll('[data-lf-mq-toggle]');
  Array.prototype.forEach.call(buttons, function (btn) {
    var mq = btn.closest('.lf-marquee');
    if (!mq) return;
    btn.addEventListener('click', function () {
      var paused = mq.classList.toggle('is-paused');
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      var label = paused ? btn.getAttribute('data-play-label') : btn.getAttribute('data-pause-label');
      if (label) btn.setAttribute('aria-label', label);
      var glyph = btn.querySelector('.lf-icon');
      if (glyph) glyph.textContent = paused ? 'play_arrow' : 'pause';
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
